import * as Yup from 'yup';
import { DatePicker } from '@yoweb/ui/components/DatePicker';
import { Grid } from '@yoweb/ui/components/Grid';
import { Text } from '@yoweb/ui/components/typography';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getInitialValues = function getInitialValues(seconds) {
  var includeInitialValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var initalValues = {};
  var initial = includeInitialValues && seconds;

  if (initial) {
    initalValues = {
      date: initial * 1000,
      time: initial * 1000
    };
  }

  return initalValues;
};
export var getAnswerValues = function getAnswerValues(date, time) {
  if (typeof date === 'number' && typeof time === 'number') {
    var dateObj = new Date(date);
    var timeObj = new Date(time);
    dateObj.setUTCHours(timeObj.getUTCHours());
    dateObj.setUTCMinutes(timeObj.getUTCMinutes());
    dateObj.setUTCSeconds(timeObj.getUTCSeconds());
    return {
      seconds: Math.floor(dateObj.getTime() / 1000),
      nanos: 0
    };
  }
};
export var getBaseSchema = function getBaseSchema(t, isRequired) {
  var schema = Yup.number();
  return Yup.object().shape({
    date: isRequired ? schema.required(t('validation.required', {
      ns: 'common'
    })) : schema,
    time: isRequired ? schema.required(t('validation.required', {
      ns: 'common'
    })) : schema
  });
};
export var DateTime = function DateTime(_ref) {
  var isDisabled = _ref.isDisabled,
      values = _ref.values,
      setValues = _ref.setValues,
      instructionHint = _ref.instructionHint,
      inputFieldHint = _ref.inputFieldHint,
      inputFieldHintTime = _ref.inputFieldHintTime,
      id = _ref.id,
      minDate = _ref.minDate;
  var _ref2 = values,
      date = _ref2.date,
      time = _ref2.time;
  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: "small4",
    children: [instructionHint && /*#__PURE__*/_jsx(Text, {
      size: "md",
      children: instructionHint
    }), /*#__PURE__*/_jsx(DatePicker, {
      id: "".concat(id, ".date"),
      name: "".concat(id, ".date"),
      label: inputFieldHint !== null && inputFieldHint !== void 0 ? inputFieldHint : '',
      disabled: isDisabled,
      minDate: minDate,
      selected: date ? new Date(date) : undefined,
      onChange: function onChange(newDate) {
        if (newDate) {
          setValues === null || setValues === void 0 ? void 0 : setValues({
            date: newDate.getTime(),
            time: time
          });
        }
      }
    }), /*#__PURE__*/_jsx(DatePicker, {
      id: "".concat(id, ".time"),
      name: "".concat(id, ".time"),
      label: inputFieldHintTime !== null && inputFieldHintTime !== void 0 ? inputFieldHintTime : '',
      disabled: isDisabled || !date,
      selected: time ? new Date(time) : undefined,
      onChange: function onChange(newDateTime) {
        if (newDateTime) {
          setValues === null || setValues === void 0 ? void 0 : setValues({
            date: date,
            time: newDateTime.getTime()
          });
        }
      },
      showTimeSelect: true,
      showTimeSelectOnly: true,
      timeIntervals: 15 // TODO: localize this
      ,
      dateFormat: "h:mm aa"
    })]
  });
};